import React from 'react';
import { T } from 'shared/helper/translate';
import Link from 'shared/components/Link';
var DropdownItems = function DropdownItems(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (item, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.label
    }, /*#__PURE__*/React.createElement("li", null, item.element ? item.element : /*#__PURE__*/React.createElement(Link, {
      className: "dropdown-item fw-normal",
      to: item.action
    }, /*#__PURE__*/React.createElement(T, {
      source: item.label
    }))), i !== items.length - 1 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("hr", {
      className: "dropdown-divider"
    })));
  }));
};
export default DropdownItems;